"use strict";

var _classCallCheck = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@eth-sdk/utils");

var Eth = /*#__PURE__*/function () {
  function Eth(query) {
    _classCallCheck(this, Eth);

    this.query = query; //
  }

  _createClass(Eth, [{
    key: "getBalance",
    value: function getBalance(address) {
      var tag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'latest';
      return this.query.send(Eth.Methods.GetBalance, utils_1.toChecksumAddress(address), utils_1.isTag(tag) ? tag : utils_1.toHex(tag)).then(function (raw) {
        return utils_1.toBN(raw);
      });
    }
  }, {
    key: "getStorageAt",
    value: function getStorageAt(address, position) {
      var tag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'latest';
      return this.query.send(Eth.Methods.GetStorageAt, utils_1.toChecksumAddress(address), utils_1.toHex(position), utils_1.isTag(tag) ? tag : utils_1.toHex(tag));
    }
  }, {
    key: "getTransactionCount",
    value: function getTransactionCount(address) {
      var tag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'latest';
      return this.query.send(Eth.Methods.GetTransactionCount, utils_1.toChecksumAddress(address), utils_1.isTag(tag) ? tag : utils_1.toHex(tag)).then(function (raw) {
        return utils_1.toNumber(raw);
      });
    }
  }, {
    key: "getBlockTransactionCountByHash",
    value: function getBlockTransactionCountByHash(hash) {
      return this.query.send(Eth.Methods.GetBlockTransactionCountByHash, hash).then(function (raw) {
        return utils_1.toNumber(raw);
      });
    }
  }, {
    key: "getBlockTransactionCountByNumber",
    value: function getBlockTransactionCountByNumber() {
      var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'latest';
      return this.query.send(Eth.Methods.GetBlockTransactionCountByNumber, utils_1.isTag(tag) ? tag : utils_1.toHex(tag)).then(function (raw) {
        return utils_1.toNumber(raw);
      });
    }
  }, {
    key: "getCode",
    value: function getCode(address) {
      var tag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'latest';
      return this.query.send(Eth.Methods.GetCode, utils_1.toChecksumAddress(address), utils_1.isTag(tag) ? tag : utils_1.toHex(tag));
    }
  }, {
    key: "sign",
    value: function sign(address, data) {
      return this.query.send(Eth.Methods.Sign, utils_1.toChecksumAddress(address), utils_1.toHex(data));
    }
  }, {
    key: "sendTransaction",
    value: function sendTransaction(options) {
      var from = options.from,
          to = options.to,
          gas = options.gas,
          gasPrice = options.gasPrice,
          value = options.value,
          data = options.data,
          nonce = options.nonce;
      return this.query.send(Eth.Methods.SendTransaction, utils_1.cleanEmpty({
        from: utils_1.toChecksumAddress(from),
        to: utils_1.toChecksumAddress(to),
        gas: utils_1.toHex(gas, null),
        gasPrice: utils_1.toHex(gasPrice, null),
        value: utils_1.toHex(value, null),
        data: utils_1.toHex(data, '0x'),
        nonce: utils_1.toHex(nonce, null)
      }));
    }
  }, {
    key: "sendRawTransaction",
    value: function sendRawTransaction(data) {
      return this.query.send(Eth.Methods.SendRawTransaction, utils_1.toHex(data));
    }
  }, {
    key: "call",
    value: function call(options) {
      var tag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'latest';
      var from = options.from,
          to = options.to,
          gas = options.gas,
          gasPrice = options.gasPrice,
          value = options.value,
          data = options.data;
      return this.query.send(Eth.Methods.Call, utils_1.cleanEmpty({
        from: utils_1.toChecksumAddress(from),
        to: utils_1.toChecksumAddress(to),
        gas: utils_1.toHex(gas, null),
        gasPrice: utils_1.toHex(gasPrice, null),
        value: utils_1.toHex(value, null),
        data: utils_1.toHex(data, null)
      }), utils_1.isTag(tag) ? tag : utils_1.toHex(tag));
    }
  }, {
    key: "estimateGas",
    value: function estimateGas(options) {
      var from = options.from,
          to = options.to,
          gas = options.gas,
          gasPrice = options.gasPrice,
          value = options.value,
          data = options.data;
      return this.query.send(Eth.Methods.EstimateGas, utils_1.cleanEmpty({
        from: utils_1.toChecksumAddress(from),
        to: utils_1.toChecksumAddress(to),
        gas: utils_1.toHex(gas, null),
        gasPrice: utils_1.toHex(gasPrice, null),
        value: utils_1.toHex(value, null),
        data: utils_1.toHex(data, null)
      })).then(function (result) {
        return utils_1.toNumber(result);
      });
    }
  }, {
    key: "getBlockByHash",
    value: function getBlockByHash() {
      var hash;
      var returnTransactionObjects;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      hash = args[0];
      returnTransactionObjects = args[1];
      return this.query.send(Eth.Methods.GetBlockByHash, hash, !!returnTransactionObjects).then(function (raw) {
        return Eth.prepareBlockResultWithTransactions(raw);
      });
    }
  }, {
    key: "getBlockByNumber",
    value: function getBlockByNumber() {
      var number;
      var returnTransactionObjects;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      number = args[0];
      returnTransactionObjects = args[1];
      return this.query.send(Eth.Methods.GetBlockByNumber, utils_1.toHex(number), !!returnTransactionObjects).then(function (raw) {
        return Eth.prepareBlockResultWithTransactions(raw);
      });
    }
  }, {
    key: "getTransaction",
    value: function getTransaction(hash) {
      return this.query.send(Eth.Methods.GetTransactionByHash, hash).then(function (raw) {
        return Eth.prepareTransactionResult(raw);
      });
    }
  }, {
    key: "getTransactionReceipt",
    value: function getTransactionReceipt(hash) {
      return this.query.send(Eth.Methods.GetTransactionReceipt, hash).then(function (raw) {
        if (!raw) {
          return null;
        }

        var cumulativeGasUsed = raw.cumulativeGasUsed,
            gasUsed = raw.gasUsed,
            contractAddress = raw.contractAddress,
            logs = raw.logs,
            status = raw.status;
        return {
          contractAddress: utils_1.toChecksumAddress(contractAddress),
          cumulativeGasUsed: utils_1.toNumber(cumulativeGasUsed),
          gasUsed: utils_1.toNumber(gasUsed),
          logs: logs.map(function (log) {
            return Eth.prepareLogResult(log);
          }),
          success: status === '0x1'
        };
      });
    }
  }, {
    key: "getLogs",
    value: function getLogs(options) {
      var fromBlock = options.fromBlock,
          toBlock = options.toBlock,
          topics = options.topics,
          address = options.address;
      return this.query.send(Eth.Methods.GetLogs, utils_1.cleanEmpty({
        topics: topics,
        address: address,
        fromBlock: utils_1.isTag(fromBlock) ? fromBlock : utils_1.toHex(fromBlock, null),
        toBlock: utils_1.isTag(toBlock) ? toBlock : utils_1.toHex(toBlock, null)
      })).then(function (raws) {
        return Array.isArray(raws) ? raws.map(function (raw) {
          return Eth.prepareLogResult(raw);
        }) : [];
      });
    }
  }, {
    key: "chainId",
    get: function get() {
      return this.query.send(Eth.Methods.ChainId).then(function (raw) {
        return utils_1.toNumber(raw);
      });
    }
  }, {
    key: "gasPrice",
    get: function get() {
      return this.query.send(Eth.Methods.GasPrice).then(function (raw) {
        return utils_1.toBN(raw, null);
      });
    }
  }, {
    key: "accounts",
    get: function get() {
      return this.query.send(Eth.Methods.Accounts).then(function (accounts) {
        return accounts.map(function (account) {
          return utils_1.toChecksumAddress(account);
        });
      });
    }
  }, {
    key: "blockNumber",
    get: function get() {
      return this.query.send(Eth.Methods.BlockNumber).then(function (raw) {
        return utils_1.toNumber(raw);
      });
    }
  }, {
    key: "pendingTransactions",
    get: function get() {
      return this.query.send(Eth.Methods.PendingTransactions).then(function (raws) {
        return Array.isArray(raws) ? raws.map(function (raw) {
          return Eth.prepareTransactionResult(raw);
        }) : [];
      });
    }
  }], [{
    key: "prepareBlockResult",
    value: function prepareBlockResult(raw) {
      if (!raw) {
        return null;
      }

      var hash = raw.hash,
          number = raw.number,
          gasLimit = raw.gasLimit,
          gasUsed = raw.gasUsed;
      return {
        hash: hash,
        number: utils_1.toNumber(number),
        gasLimit: utils_1.toNumber(gasLimit),
        gasUsed: utils_1.toNumber(gasUsed)
      };
    }
  }, {
    key: "prepareBlockResultWithTransactions",
    value: function prepareBlockResultWithTransactions(raw) {
      var _this = this;

      if (!raw) {
        return null;
      }

      var transactions = raw.transactions;
      return Object.assign(Object.assign({}, this.prepareBlockResult(raw)), {
        transactions: transactions.map(function (transaction) {
          return typeof transaction === 'object' ? _this.prepareTransactionResult(transaction) : transaction;
        })
      });
    }
  }, {
    key: "prepareTransactionResult",
    value: function prepareTransactionResult(raw) {
      if (!raw) {
        return null;
      }

      var blockHash = raw.blockHash,
          blockNumber = raw.blockNumber,
          hash = raw.hash,
          index = raw.transactionIndex,
          from = raw.from,
          to = raw.to,
          gas = raw.gas,
          gasPrice = raw.gasPrice,
          input = raw.input,
          value = raw.value;
      return {
        blockHash: blockHash,
        hash: hash,
        input: input,
        from: utils_1.toChecksumAddress(from),
        to: utils_1.toChecksumAddress(to),
        blockNumber: utils_1.toNumber(blockNumber),
        index: utils_1.toNumber(index),
        gas: utils_1.toNumber(gas),
        gasPrice: utils_1.toBN(gasPrice),
        value: utils_1.toBN(value)
      };
    }
  }, {
    key: "prepareLogResult",
    value: function prepareLogResult(raw) {
      if (!raw) {
        return null;
      }

      var index = raw.logIndex,
          transactionHash = raw.transactionHash,
          transactionIndex = raw.transactionIndex,
          blockHash = raw.blockHash,
          blockNumber = raw.blockNumber,
          address = raw.address,
          data = raw.data,
          topics = raw.topics;
      return {
        transactionHash: transactionHash,
        blockHash: blockHash,
        data: data,
        topics: topics,
        index: utils_1.toNumber(index),
        transactionIndex: utils_1.toNumber(transactionIndex),
        blockNumber: utils_1.toNumber(blockNumber),
        address: utils_1.toChecksumAddress(address)
      };
    }
  }]);

  return Eth;
}();

exports.Eth = Eth;

(function (Eth) {
  var Methods;

  (function (Methods) {
    Methods["ChainId"] = "eth_chainId";
    Methods["GasPrice"] = "eth_gasPrice";
    Methods["Accounts"] = "eth_accounts";
    Methods["BlockNumber"] = "eth_blockNumber";
    Methods["GetBalance"] = "eth_getBalance";
    Methods["GetStorageAt"] = "eth_getStorageAt";
    Methods["GetTransactionCount"] = "eth_getTransactionCount";
    Methods["GetBlockTransactionCountByHash"] = "eth_getBlockTransactionCountByHash";
    Methods["GetBlockTransactionCountByNumber"] = "eth_getBlockTransactionCountByNumber";
    Methods["GetCode"] = "eth_getCode";
    Methods["Sign"] = "eth_sign";
    Methods["SendTransaction"] = "eth_sendTransaction";
    Methods["SendRawTransaction"] = "eth_sendRawTransaction";
    Methods["Call"] = "eth_call";
    Methods["EstimateGas"] = "eth_estimateGas";
    Methods["GetBlockByHash"] = "eth_getBlockByHash";
    Methods["GetBlockByNumber"] = "eth_getBlockByNumber";
    Methods["GetTransactionByHash"] = "eth_getTransactionByHash";
    Methods["GetTransactionReceipt"] = "eth_getTransactionReceipt";
    Methods["PendingTransactions"] = "eth_pendingTransactions";
    Methods["GetLogs"] = "eth_getLogs";
    Methods["Subscribe"] = "eth_subscribe";
    Methods["Unsubscribe"] = "eth_unsubscribe";
  })(Methods = Eth.Methods || (Eth.Methods = {}));
})(Eth = exports.Eth || (exports.Eth = {}));